import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Privacy from "./pages/info/privacy";
import TermsAndConditions from "./pages/info/terms-and-conditions";
import Layout from "./layout/layout";
import Home from "./pages/home";
import Vsl1Page from "./pages/bg/vsl-1";
import Vsl3Page from "./pages/bg/vsl-3";
import Contact from "./pages/info/contact";
import InfoLayout from "./layout/info-layout";
import ReturnPolicy from "./pages/info/return-policy";
import UpsellOptivista from "./pages/bg/upsell-optivista";
import UpsellDownsellLayout from "./layout/ud-layout";
import UpsellGlucoGen6 from "./pages/bg/upsell-glucogen-6";
import DownsellGlucoGen3 from "./pages/bg/downsell-glucogen-3";
import Tsl from "./pages/bg/tsl";
import ThankYou from "./pages/bg/thank-you";
import Vsl2Page from "./pages/bg/vsl-2";
import Vsl4Page from "./pages/bg/vsl-4";
import Vsl5Page from "./pages/bg/vsl-5";
import VslPage from "./pages/bg/vsl";
import DtcPage from "./pages/bg/dtc";
import LayoutNoPopup from "./layout/layout-nopopup";
import VslShortPage from "./pages/bg/vsl-short";
import TestimonialPage from "./pages/bg/testimonial";
import Vsl5NgPage from "./pages/bg/vsl-5-ng";

const AppRouter = () => (
    <Router>
        <Routes>
        <Route path="/info" element={<InfoLayout />}>
                <Route path="privacy" element={<Privacy />} />
                <Route path="terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="contact"  element={<Contact />} />
                <Route path="return-policy"  element={<ReturnPolicy />} />
            </Route>
            <Route path="/bg/ud/" element={<UpsellDownsellLayout />}>
                <Route path="optivista-u" element={<UpsellOptivista />} />
                <Route path="glucogen-u-6" element={<UpsellGlucoGen6 />} />
                <Route path="glucogen-d-3" element={<DownsellGlucoGen3 />} />
            </Route>
            <Route path="/bg/np" element={<LayoutNoPopup />}>
                <Route path="dtc" element={<DtcPage />} />
                <Route path="testimonial" element={<TestimonialPage />} />
            </Route>
            <Route path="/" element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="/bg/vsl" element={<VslPage />} />
                <Route path="/bg/vsl-1" element={<Vsl1Page />} />
                <Route path="/bg/vsl-2" element={<Vsl2Page />} />
                <Route path="/bg/vsl-3" element={<Vsl3Page />} />
                <Route path="/bg/vsl-4" element={<Vsl4Page />} />
                <Route path="/bg/vsl-5" element={<Vsl5Page />} />
                <Route path="/bg/vsl-5-ng" element={<Vsl5NgPage />} />
                <Route path="/bg/vsl-short" element={<VslShortPage />} />
                <Route path="/bg/tsl" element={<Tsl />} />
                <Route path="/bg/thank-you" element={<ThankYou />} />
            </Route>
            <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    </Router>
);

export default AppRouter;